// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router1 from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueRouter from 'vue-router'
import VueSwal from 'vue-swal'
import VueResource from 'vue-resource'

// issue - call these component with refs during mounted of child will crash as the refs is not populated yet
// // custom high reuse component, should follow W3C rules for custom tag names (all-lowercase, must contain a hyphen)
// Vue.component('AppAddButton', () => import('@/components/App/AppAddButton'));
// Vue.component('AppFilter', () => import('@/components/App/AppFilter'));
// Vue.component('AppFilterDateRange', () => import('@/components/App/AppFilterDateRange'));
// Vue.component('AppForm', () => import('@/components/App/AppForm'));
// Vue.component('AppModalForm', () => import('@/components/App/AppModalForm'));
// Vue.component('AppPaging', () => import('@/components/App/AppPaging'));
// Vue.component('AppSearch', () => import('@/components/App/AppSearch'));
// Vue.component('AppTable', () => import('@/components/App/AppTable'));

// Vue.component('TemplateAlert', () => import('@/components/Template/TemplateAlert'));
// Vue.component('TemplateBasic', () => import('@/components/Template/TemplateBasic'));
// Vue.component('TemplateFeedback', () => import('@/components/Template/TemplateFeedback'));
// Vue.component('TemplateModal', () => import('@/components/Template/TemplateModal'));


Vue.use(VueAxios, axios)

Vue.config.productionTip = false

let {router} = router1

// /* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   router,
//   components: { App },
//   template: '<App/>'
// })

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

Vue.use(VueRouter)
Vue.use(VueSwal)
// Vue.use(VueResource)



// WEBPACK FOOTER //
// ./src/main.js